import { setIsHome, setHelpLink } from './actions';
import { initalAction as mdInitalAction } from '../md/initalAction';

export const initalAction = watchContext => (dispatch) => {
  let isHome = false;
  if (watchContext && watchContext.page === 'home') {
    isHome = true;
  }
  let helpLink = '/newhelp/';
  if (watchContext && watchContext.page === 'homePageVendre') {
    helpLink = '/event/astuces_vendeur?xtatc=PUB-[PMC]-[V]-[home-vendre]-[aide]-[astuces-vendeurs]-[]-[]';
  }


  return Promise.all([
    dispatch(setIsHome(isHome)),
    dispatch(setHelpLink(helpLink)),
    dispatch(mdInitalAction(watchContext)),
  ]);
};
